const styleSheet = (theme: any) => ({});

export default styleSheet;
try {
    // @ts-ignore
    styles.displayName = "styles";
    // @ts-ignore
    styles.__docgenInfo = { "description": "", "displayName": "styles", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/Ethnicity/styles.ts#styles"] = { docgenInfo: styles.__docgenInfo, name: "styles", path: "src/shared/containers/Filter/Demographics/Ethnicity/styles.ts#styles" };
}
catch (__react_docgen_typescript_loader_error) { }